import { isNativeIOS } from './platform'

// Build-time feature flags. This file is the ONE place they are defined.
//
// ── Oura on iOS ──────────────────────────────────────────────────────
//
// Flag: VITE_IOS_OURA_ENABLED (Vite env var, read at build time).
//
// Decision (Jared, Oct 26 2026): App Store 1.0 ships WITHOUT the Oura
// connection in the native iOS app; Oura returns in 1.1. App Review
// rejected build 13 under 1.4.1 / 2.1 / 2.1(a) for treating Oura as
// external hardware. Nothing Oura-related is deleted: the API client,
// the haiven://oura deep-link handler, the backend routes and crons,
// and the whole web app keep working. Only the iOS *entry points*
// (onboarding connect step, Wearables Oura card, Profile Oura row,
// Oura-branded labels and nudges) are hidden.
//
// Behaviour:
//   • Web / PWA (any non-iOS platform): Oura UI always shows. The flag
//     has no effect there.
//   • Native iOS (Capacitor shell): Oura UI shows only when the flag
//     resolves true.
//
// Resolution order: VITE_IOS_OURA_ENABLED=true|1 forces on,
// VITE_IOS_OURA_ENABLED=false|0 forces off, otherwise the default below.
//
// TO RE-ENABLE OURA ON iOS FOR 1.1: change the next line to `true`
// (or build the iOS bundle with VITE_IOS_OURA_ENABLED=true).
const IOS_OURA_DEFAULT = false

export function iosOuraEnabled() {
  const env = (typeof import.meta !== 'undefined' && import.meta.env) || {}
  const raw = String(env.VITE_IOS_OURA_ENABLED ?? '').trim().toLowerCase()
  if (raw === 'true' || raw === '1') return true
  if (raw === 'false' || raw === '0') return false
  return IOS_OURA_DEFAULT
}

// The single gate every Oura entry point checks. Evaluated at render
// time (not module load) so the platform is known and tests can stub it.
export function isOuraUIEnabled() {
  return !isNativeIOS() || iosOuraEnabled()
}
